<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Parâmetros de Ocorrência</h4>
              <a class="heading-elements-toggle"
                ><i class="fa fa-ellipsis-v font-medium-3"></i
              ></a>
              <div class="heading-elements">
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="getPermissionFw('paramocorrencia.store')"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('paramocorrencia.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('paramocorrencia.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'param_ocorrencia'">
                  </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/paramocorrencia"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="parocorrenId"
                    detail-row-component="param-ocorrencia-detalhes"
                    pagination-path="meta"
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="reentrega" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.reentrega != null && props.rowData.reentrega.valor == 1"
                        >{{ props.rowData.reentrega.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.reentrega != null && props.rowData.reentrega.valor == 2"
                        >{{ props.rowData.reentrega.descr }}</span
                      >
                    </template>
                    <template slot="finalizacaoEntrega" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.finalizacaoEntrega.valor == 1"
                        >{{ props.rowData.finalizacaoEntrega.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.finalizacaoEntrega.valor == 2"
                        >{{ props.rowData.finalizacaoEntrega.descr }}</span
                      >
                    </template>
                    <template slot="tpIsend" slot-scope="props">
                      <span>{{ props.rowData.tpIsend.descr }}</span>
                    </template>
                    <template slot="tpOperacao" slot-scope="props">
                      <span>{{ props.rowData.tpOperacao.descr }}</span>
                    </template>
                    <template slot="usaConferencia" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.usaConferencia != null && props.rowData.usaConferencia.valor == 1"
                        >{{ props.rowData.usaConferencia.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.usaConferencia != null && props.rowData.usaConferencia.valor == 2"
                        >{{ props.rowData.usaConferencia.descr }}</span
                      >
                    </template>
                    <template slot="exigeTratativa" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.exigeTratativa != null && props.rowData.exigeTratativa.valor == 1"
                        >{{ props.rowData.exigeTratativa.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.exigeTratativa != null && props.rowData.exigeTratativa.valor == 2"
                        >{{ props.rowData.exigeTratativa.descr }}</span
                      >
                    </template>
                    <template slot="cancelaCteNstech" slot-scope="props">
                      <span
                          class="badge badge-success"
                          v-if="props.rowData.cancelaCteNstech != null && props.rowData.cancelaCteNstech.valor == 1"
                      >{{ props.rowData.cancelaCteNstech.descr }}</span
                      >
                      <span
                          class="badge badge-danger"
                          v-if="props.rowData.cancelaCteNstech != null && props.rowData.cancelaCteNstech.valor == 2"
                      >{{ props.rowData.cancelaCteNstech.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Editar"
                          v-if="getPermissionFw('paramocorrencia.update')"
                          ><i class="fa fa-edit"></i
                        ></a>
                        <a
                          v-if="props.rowData.paramOcorrenciaProcesso.length > 0"
                          @click="onDetail(props.rowData)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                        <span v-if="getPermissionFw('paramocorrencia.status')">
                          <a
                            v-if="props.rowData.status.valor == 2"
                            @click="
                              onActivateDesactivate(1, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Ativar"
                            ><i class="fa fa-thumbs-o-up"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 1"
                            @click="
                              onActivateDesactivate(2, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Inativar"
                            ><i class="fa fa-thumbs-o-down"></i
                          ></a>
                        </span>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ParamOcorrenciaForm
        ref="paramsform"
        :metodo="onFilterReset"
        :tabela="'param_ocorrencia'"
        :rota="'paramocorrencia'"
      >
      </ParamOcorrenciaForm>
    </div>
  </div>
</template>
<script>
import Vuetable from "../../components/Vuetable";
import VuetablePagination from "../../components/VuetablePagination";
import VuetablePaginationInfo from "../../components/VuetablePaginationInfo";
import ParamFilterBar from "./ParamFilterBar";
import ParamOcorrenciaFilterBar from "./ParamOcorrenciaFilterBar.vue";
import ParamOcorrenciaForm from "./ParamOcorrenciaForm";
import ParamOcorrenciaDetalhes from "./ParamOcorrenciaDetalhes";

Vue.component("param-ocorrencia-detalhes", ParamOcorrenciaDetalhes);

// Ocorrências que não devem aparecer na listagem de parâmetro de ocorrência.
// Esconder pelo parâmetro usa_conferencia não serve: ele é validado na escrita
// (service-isend recusa o apontamento e a falta automática), então o filtro fica aqui.
const CDS_OCULTOS = [147];

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ParamOcorrenciaForm,
    "vuetable-filterbar": ParamOcorrenciaFilterBar
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      optionsLivStatus: [],
      optionsLivFinalizacao: [],
      optionsTpIsend: [],
      optionsTpOperacao: [],
      optionsReentrega: [],
      optionsPortalTransp: [],
      optionsUsaConferencia: [],
      optionsExigeTratativa: [],
      optionsTpProcessos: [],
      optionsCancelaCteNstech: [],
      form: new Form({ cd: "", descr: "", parocorren_id: "", status: [] }),
      helpForm: new Form({
        status: "",
        statusRecord: [],
        params: []
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned"
        },
        {
          name: "cd",
          title: "Código",
          sortField: "cd"
        },
        {
          name: "descr",
          title: "Descrição",
          sortField: "descr"
        },
        {
          name: "__slot:reentrega",
          title: "Reentrega",
          sortField: "reentrega"
        },
        {
          name: "__slot:finalizacaoEntrega",
          title: "Finalizou entrega?",
          sortField: "finalizacaoEntrega"
        },
        {
          name: "__slot:tpIsend",
          title: "Tipo Isend",
          sortField: "tpIsend"
        },
        {
          name: "__slot:tpOperacao",
          title: "Tipo Operação",
          sortField: "tpOperacao"
        },
        {
          name: "portalTransp.descr",
          title: "Portal Transpotador ?",
          sortField: "portalTransp"
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status"
        },
        {
          name: "__slot:usaConferencia",
          title: "Usa Conferencia?",
          sortField: "usaConferencia"
        },
        {
          name: "__slot:exigeTratativa",
          title: "Exige Tratativa?",
          sortField: "exigeTratativa"
        },
        {
          name: "__slot:cancelaCteNstech",
          title: "Cancela CTe na NStech?",
          sortField: "cancelaCteNstech"
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned"
        }
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  mounted() {
    this.getLivGeral();
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", e => this.onFilterReset());
  },
  methods: {
    // Hook do Vuetable: roda no load-success, antes de popular tableData.
    transform(body) {
      if (!body || !Array.isArray(body.data)) {
        return body;
      }

      const visiveis = body.data.filter(row => !CDS_OCULTOS.includes(Number(row.cd)));
      const removidas = body.data.length - visiveis.length;
      if (removidas === 0) {
        return body;
      }

      body.data = visiveis;
      if (body.meta) {
        if (typeof body.meta.total === "number") {
          body.meta.total -= removidas;
        }
        if (typeof body.meta.to === "number") {
          body.meta.to -= removidas;
        }
      }

      return body;
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        cd: data_filter.cd,
        descr: data_filter.descr,
        finalizacao_entrega: data_filter.finalizacao_entrega ? data_filter.finalizacao_entrega.value : null,
        reentrega: data_filter.reentrega ? data_filter.reentrega.value : null,
        status: data_filter.status ? data_filter.status.value : null,
        tp_operacao: data_filter.tp_operacao ? data_filter.tp_operacao.value : null,
        tp_isend: data_filter.tp_isend ? data_filter.tp_isend.value : null,
        portal_transp: data_filter.portal_transp ? data_filter.portal_transp.value : null,
        usa_conferencia: data_filter.usa_conferencia ? data_filter.usa_conferencia.value : null,
        exige_tratativa: data_filter.exige_tratativa ? data_filter.exige_tratativa.value : null,
        tp_processo: data_filter.tp_processo ? data_filter.tp_processo.join(',') : '',
        cancela_cte_nstech: data_filter.cancela_cte_nstech ? data_filter.cancela_cte_nstech.value : null,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function() {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.parocorrenId);
    },
    getLivGeral() {
      this.helpForm
        .get("/api/paramocorrencia/jsonlist")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.tp_isend.forEach(obj => {
            this.optionsTpIsend.push({ label: obj.descr, value: obj.valor });
          });
          response.tp_operacao.forEach(obj => {
            this.optionsTpOperacao.push({ label: obj.descr, value: obj.valor });
          });
          response.status.forEach(obj => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });
          response.finalizacao_entrega.forEach(obj => {
            this.optionsLivFinalizacao.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.reentrega.forEach(obj => {
            this.optionsReentrega.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.portal_transp.forEach(obj => {
            this.optionsPortalTransp.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.usa_conferencia.forEach(obj => {
            this.optionsUsaConferencia.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.exige_tratativa.forEach(obj => {
            this.optionsExigeTratativa.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.tp_processo.forEach(obj => {
            this.optionsTpProcessos.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.cancela_cte_nstech.forEach(obj => {
            this.optionsCancelaCteNstech.push({
              label: obj.descr,
              value: obj.valor
            });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },
    onCreate() {
      this.$refs.paramsform.onCreate();
    },
    onEdit(data, index) {
      this.id = data.parocorrenId;
      this.$refs.paramsform.onEdit(data, index, this.id);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({ id: data.parocorrenId, status: action} );
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach(obj => {
          this.helpForm.statusRecord.push(obj);
        });
      }
      this.$refs.paramsform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      }
    }
  }
};
</script>
